import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_ChooseForm = _resolveComponent("ChooseForm")!
  const _component_SelectedProducts = _resolveComponent("SelectedProducts")!
  const _component_NotesContent = _resolveComponent("NotesContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: "edit_adjustment",
        items: _ctx.breadcrumbItems,
        showHome: false
      }, null, 8, ["items"]),
      _createVNode(_component_ChooseForm, {
        warehouses: _ctx.warehouses,
        warehouseId: _ctx.form.warehouse_id,
        "onUpdate:warehouseId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.warehouse_id) = $event)),
        referenceNo: _ctx.form.ref,
        "onUpdate:referenceNo": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.ref) = $event)),
        adjustmentDate: _ctx.form.date,
        "onUpdate:adjustmentDate": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.date) = $event)),
        warehouseLocked: _ctx.warehouseLockedToProfile,
        isLoading: _ctx.isLoadingData,
        onSearchProduct: _ctx.handleProductSearch,
        searchResults: _ctx.searchResults,
        showResults: _ctx.showResults,
        onAddProduct: _ctx.addProduct
      }, null, 8, ["warehouses", "warehouseId", "referenceNo", "adjustmentDate", "warehouseLocked", "isLoading", "onSearchProduct", "searchResults", "showResults", "onAddProduct"]),
      _createVNode(_component_SelectedProducts, {
        products: _ctx.selectedProducts,
        onRemove: _ctx.removeProduct,
        onUpdateQuantity: _ctx.updateProductQuantity,
        onUpdateType: _ctx.updateProductType
      }, null, 8, ["products", "onRemove", "onUpdateQuantity", "onUpdateType"]),
      _createVNode(_component_NotesContent, {
        modelValue: _ctx.form.note,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.note) = $event)),
        onSubmit: _ctx.handleSubmit,
        isSubmitting: _ctx.isSubmitting
      }, null, 8, ["modelValue", "onSubmit", "isSubmitting"]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}